(() => {

  const SELECTOR = '[data-cart-rewards]';

  let syncRunning = false;
  let syncScheduled = false;


  /* ========================================================
     HILFSFUNKTIONEN
     ======================================================== */

  function getRewardElement() {
    return document.querySelector(SELECTOR);
  }


  function getConfig() {

  const element = getRewardElement();

  if (!element) {
    console.warn(
      '[Cart Rewards] Reward-Element wurde nicht gefunden.'
    );

    return null;
  }


  const config = {
    element,

    gift30Enabled:
      element.getAttribute('data-gift-30-enabled') === 'true',

    shippingEnabled:
      element.getAttribute('data-shipping-enabled') === 'true',

    gift55Enabled:
      element.getAttribute('data-gift-55-enabled') === 'true',

    gift30Variant:
      Number(
        element.getAttribute('data-gift-30')
      ),

    gift55Variant:
      Number(
        element.getAttribute('data-gift-55')
      ),

    threshold30:
      Number(
        element.getAttribute('data-threshold-30') ||
        3000
      ),

    thresholdShipping:
      Number(
        element.getAttribute('data-threshold-shipping') ||
        4500
      ),

    threshold55:
      Number(
        element.getAttribute('data-threshold-55') ||
        5500
      )
  };


  console.log(
    '[Cart Rewards] Config:',
    {
      gift30Variant: config.gift30Variant,
      gift55Variant: config.gift55Variant,
      threshold30: config.threshold30,
      thresholdShipping: config.thresholdShipping,
      threshold55: config.threshold55
    }
  );


  return config;
}


  function isAutoGift(item) {

    if (!item.properties) {
      return false;
    }

    return (
      item.properties._auto_gift === 'true' ||
      item.properties._auto_gift === true
    );
  }


  function getQualifyingTotal(cart) {

    return cart.items.reduce((total, item) => {

      if (isAutoGift(item)) {
        return total;
      }

      return total + item.final_line_price;

    }, 0);
  }


  async function getCart() {

    const response = await fetch(
      `${window.Shopify.routes.root}cart.js`,
      {
        headers: {
          Accept: 'application/json',
          'X-Auto-Gift-Sync': '1'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Warenkorb konnte nicht geladen werden.');
    }

    return response.json();
  }
  function getCartSections() {
  const cartDrawer =
    document.querySelector('cart-drawer');

  if (
    !cartDrawer ||
    typeof cartDrawer.getSectionsToRender !== 'function'
  ) {
    return [];
  }

  return cartDrawer
    .getSectionsToRender()
    .map(section => section.id);
}


function renderCartAfterReward(response) {
  const cartDrawer =
    document.querySelector('cart-drawer');

  if (
    !cartDrawer ||
    typeof cartDrawer.renderContents !== 'function' ||
    !response ||
    !response.sections
  ) {
    return;
  }

  cartDrawer.renderContents(response);

  window.requestAnimationFrame(async () => {
  const config = getConfig();

  if (!config) {
    return;
  }

  const cart = await getCart();

  updateVisualState(
    getQualifyingTotal(cart),
    config
  );
});

  console.log(
    '[Cart Rewards] Drawer nach Geschenk aktualisiert'
  );
}

  /* ========================================================
     GESCHENK SUCHEN
     ======================================================== */

  function findGift(cart, variantId) {

    return cart.items.find(item => {

      return (
        Number(item.variant_id) === Number(variantId) &&
        isAutoGift(item)
      );

    });
  }


  /* ========================================================
     GESCHENK HINZUFÜGEN
     ======================================================== */

  async function addGift(variantId, tier) {

    if (!variantId) {
        console.warn(
        `Gift variant für ${tier} € wurde nicht gefunden.`
        );

        return null;
    }

    const sections =
        getCartSections();

    const payload = {
        items: [
        {
            id: variantId,
            quantity: 1,

            properties: {
            _auto_gift: 'true',
            _gift_tier: String(tier)
            }
        }
        ]
    };


    if (sections.length) {
        payload.sections = sections;
        payload.sections_url =
        window.location.pathname;
    }


    const response = await fetch(
        `${window.Shopify.routes.root}cart/add.js`,
        {
        method: 'POST',

        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Auto-Gift-Sync': '1'
        },

        body: JSON.stringify(payload)
        }
    );


    const data =
        await response.json();


    if (!response.ok) {

        console.error(
        `Gratisgeschenk ${tier} € konnte nicht hinzugefügt werden:`,
        data
        );

        return null;
    }


    console.log(
        `Gratisgeschenk ${tier} € hinzugefügt.`
    );


    return data;
    }
  async function removeGift(lineKey) {

    if (!lineKey) {
        return null;
    }


    const sections =
        getCartSections();


    const payload = {
        id: lineKey,
        quantity: 0
    };


    if (sections.length) {
        payload.sections = sections;
        payload.sections_url =
        window.location.pathname;
    }


    const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
        method: 'POST',

        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Auto-Gift-Sync': '1'
        },

        body: JSON.stringify(payload)
        }
    );


    const data =
        await response.json();


    if (!response.ok) {

        console.error(
        'Gratisgeschenk konnte nicht entfernt werden:',
        data
        );

        return null;
    }


    return data;
    }

  function calculateProgress(
  total,
  threshold30,
  thresholdShipping,
  threshold55
) {

  /*
   * Vor dem ersten Meilenstein:
   * keine aktive Linie.
   */
  if (total < threshold30) {
    return 0;
  }


  /*
   * 30 € bis 45 €
   *
   * Visuell:
   * 30 € = 0 %
   * 45 € = 50 %
   *
   * Der mittlere Milestone liegt exakt
   * in der Mitte der Linie.
   */
  if (total < thresholdShipping) {

    const range =
      thresholdShipping - threshold30;

    const current =
      total - threshold30;

    return (
      current / range
    ) * 50;

  }


  /*
   * 45 € bis 55 €
   *
   * 45 € = 50 %
   * 55 € = 100 %
   */
  if (total < threshold55) {

    const range =
      threshold55 - thresholdShipping;

    const current =
      total - thresholdShipping;

    return (
      50 +
      (current / range) * 50
    );

  }


  return 100;
}
  /* ========================================================
     VISUELLE ANZEIGE AKTUALISIEREN
     ======================================================== */

  function updateVisualState(
    total,
    config
  ) {

    const element = getRewardElement();

    if (!element) {
      return;
    }


    const progress =
      calculateProgress(
        total,
        config.threshold30,
        config.thresholdShipping,
        config.threshold55
      );


    const trackElement =
  element.querySelector(
    '.cart-rewards__track'
  );

if (trackElement) {
  trackElement.style.setProperty(
    '--reward-progress',
    `${Math.min(progress, 100)}%`
  );
}


    element
      .querySelectorAll(
        '[data-reward-milestone]'
      )
      .forEach(milestone => {

        const tier =
          Number(
            milestone.dataset.rewardMilestone
          );

        let reached = false;


        if (tier === 30) {

          reached =
            total >= config.threshold30;

        }


        if (tier === 45) {

          reached =
            total >=
            config.thresholdShipping;

        }


        if (tier === 55) {

          reached =
            total >= config.threshold55;

        }


        milestone.classList.toggle(
          'is-reached',
          reached
        );

      });


    updateStatusMessage(
      element,
      total,
      config
    );
  }


  /* ========================================================
     STATUS TEXT
     ======================================================== */

  function formatMoney(cents) {

    return new Intl.NumberFormat(
      'de-DE',
      {
        style: 'currency',
        currency: 'EUR'
      }
    ).format(
      cents / 100
    );
  }


  function updateStatusMessage(
    element,
    total,
    config
  ) {

    const status =
      element.querySelector(
        '[data-rewards-status]'
      );

    if (!status) {
      return;
    }


    if (total >= config.threshold55) {

      status.textContent =
        '🎉 Alle Vorteile freigeschaltet!';

      return;
    }


    if (
      total >=
      config.thresholdShipping
    ) {

      const remaining =
        config.threshold55 - total;

      status.textContent =
        `Noch ${formatMoney(remaining)} bis zu deinem zweiten Gratisgeschenk`;

      return;
    }


    if (
      total >=
      config.threshold30
    ) {

      const remaining =
        config.thresholdShipping - total;

      status.textContent =
        `Noch ${formatMoney(remaining)} bis zum kostenlosen Versand`;

      return;
    }


    const remaining =
      config.threshold30 - total;

    status.textContent =
      `Noch ${formatMoney(remaining)} bis zu deinem ersten Gratisgeschenk`;
  }


  /* ========================================================
     HAUPTLOGIK
     ======================================================== */

  async function syncRewards() {

    if (syncRunning) {
      return;
    }

    const config = getConfig();

    if (!config) {
      return;
    }


    syncRunning = true;

    let cartChanged = false;
    let lastCartResponse = null;    


    try {

      let cart = await getCart();

      const qualifyingTotal =
        getQualifyingTotal(cart);


      updateVisualState(
        qualifyingTotal,
        config
      );


    /* ---------------------------------------------
      30-€-GESCHENK
      --------------------------------------------- */

    let gift30 =
      findGift(
        cart,
        config.gift30Variant
      );


    /*
    * Geschenk soll vorhanden sein,
    * wenn:
    *
    * 1. der Reward im Theme Editor aktiviert ist
    * 2. der Warenkorbwert mindestens 30 € beträgt
    */

    const gift30ShouldExist =
      config.gift30Enabled &&
      qualifyingTotal >= config.threshold30;


    if (gift30ShouldExist) {

      if (!gift30) {

        const response30 =
          await addGift(
            config.gift30Variant,
            30
          );

        if (response30) {

          lastCartResponse =
            response30;

          cartChanged = true;

          cart =
            await getCart();

        }

      }

    } else {

      /*
      * Wichtig:
      *
      * Auch wenn der Kunde bereits über 30 € liegt,
      * wird das Geschenk entfernt, sobald der
      * Theme-Editor-Haken ausgeschaltet ist.
      */

      if (gift30) {

        const response30 =
          await removeGift(
            gift30.key
          );

        if (response30) {

          lastCartResponse =
            response30;

          cartChanged = true;

          cart =
            await getCart();

        }

      }

    }

      /* ---------------------------------------------
         55-€-GESCHENK
         --------------------------------------------- */

      let gift55 =
        findGift(
          cart,
          config.gift55Variant
        );


      if (
        qualifyingTotal >=
        config.threshold55
      ) {

        if (!gift55) {

          const response55 =
            await addGift(
              config.gift55Variant,
              55
            );

          if (response55) {

            lastCartResponse =
              response55;

            cartChanged = true;

            cart =
              await getCart();

          }

        }

      } else {

        if (gift55) {

          const response55 =
            await removeGift(
              gift55.key
            );

          if (response55) {

            lastCartResponse =
              response55;

            cartChanged = true;

            cart =
              await getCart();

          }

        }

      }


      /* ---------------------------------------------
         DRAWER NACH REWARD-ÄNDERUNG AKTUALISIEREN
         --------------------------------------------- */

      if (
        cartChanged &&
        lastCartResponse
      ) {

        renderCartAfterReward(
          lastCartResponse
        );

      }
      if (
        cartChanged &&
        lastCartResponse
      ) {
        renderCartAfterReward(
          lastCartResponse
        );
      }

    } catch (error) {

      console.error(
        'Fehler bei Cart Rewards:',
        error
      );

    } finally {

      syncRunning = false;

    }
  }


  /* ========================================================
     TOOLTIP KLICK AUF MOBILE
     ======================================================== */

  document.addEventListener(
    'click',
    event => {

      const milestone =
        event.target.closest(
          '[data-reward-milestone]'
        );


      if (!milestone) {

        document
          .querySelectorAll(
            '.cart-rewards__milestone.is-open'
          )
          .forEach(item => {

            item.classList.remove(
              'is-open'
            );

          });

        return;

      }


      const currentlyOpen =
        milestone.classList.contains(
          'is-open'
        );


      document
        .querySelectorAll(
          '.cart-rewards__milestone.is-open'
        )
        .forEach(item => {

          item.classList.remove(
            'is-open'
          );

        });


      if (!currentlyOpen) {

        milestone.classList.add(
          'is-open'
        );

      }

    }
  );


  /* ========================================================
     ÄNDERUNGEN AM SHOPIFY CART ERKENNEN

     Wir beobachten cart/add.js,
     cart/change.js,
     cart/update.js usw.
     ======================================================== */

  const originalFetch =
    window.fetch.bind(window);


  window.fetch = async function(
    resource,
    options = {}
  ) {

    const response =
      await originalFetch(
        resource,
        options
      );


    try {

      const url =
        typeof resource === 'string'
          ? resource
          : resource.url;


      const headers =
        options.headers || {};


      let isOwnRequest = false;


      if (headers instanceof Headers) {

        isOwnRequest =
          headers.get(
            'X-Auto-Gift-Sync'
          ) === '1';

      } else {

        isOwnRequest =
          headers[
            'X-Auto-Gift-Sync'
          ] === '1';

      }


      const cartRequest =
        /\/cart\/(add|change|update|clear)(\.js)?/i.test(
          url
        );


      if (
        cartRequest &&
        !isOwnRequest
      ) {

        scheduleSync();

      }


    } catch (error) {

      /* keine Aktion erforderlich */

    }


    return response;
  };


  /* ========================================================
     SYNC VERZÖGERT AUSFÜHREN
     ======================================================== */

  function scheduleSync() {

    if (syncScheduled) {
      return;
    }


    syncScheduled = true;


    window.setTimeout(
      async () => {

        syncScheduled = false;

        await syncRewards();

      },
      350
    );

  }


  /* ========================================================
     INITIALISIERUNG
     ======================================================== */

  function init() {

    scheduleSync();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  window.addEventListener(
    'pageshow',
    scheduleSync
  );

})();